import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import schema from './schema';
import View from './View';
import './style.css';

const updateButtonLabelIfEmpty = (buttons) => {
  return buttons.map((btn) => {
    const link = Array.isArray(btn.link) ? btn.link[0] : btn.link;
    const label = btn.label?.trim();
    if (!label && link && (link.title || link['@id'])) {
      return {
        ...btn,
        label: link.title || link['@id'].split('/').filter(Boolean).pop(),
      };
    }
    return btn;
  });
};

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <View {...props} />

      {selected && (
        <SidebarPortal selected={selected}>
          <BlockDataForm
            schema={{
              ...schema(props),
              fieldsets: schema(props).fieldsets
                .map((fs) => {
                  let fields = fs.fields;

                  if (fs.id === 'default') {
                    if (data.usePageTitle) {
                      fields = fields.filter((f) => f !== 'title');
                    }
                    if (data.usePageDescription) {
                      fields = fields.filter((f) => f !== 'subtitle');
                    }
                    if (data.useTOC) {
                      fields = fields.filter((f) => f !== 'buttons');
                    } else {
                      // Hide TOC sub-options when TOC is off
                      fields = fields.filter(
                        (f) => !['useH2', 'useH3', 'useBlockTitles'].includes(f),
                      );
                    }
                    if (data.usePreviewImage) {
                      fields = fields.filter((f) => f !== 'backgroundImage');
                    }
                  }

                  return { ...fs, fields };
                })
                .filter((fs) => {
                  if (fs.id === 'video_options') {
                    return data.videoOnSide === true;
                  }
                  return true;
                }),
            }}
            title="Hero Block"
            onChangeField={(id, value) =>
              onChangeBlock(block, { ...data, [id]: value })
            }
            onChangeBlock={(id, newData) => {
              const updated = { ...data, ...newData };
              if (newData.buttons) {
                updated.buttons = updateButtonLabelIfEmpty(newData.buttons);
              }
              onChangeBlock(id, updated);
            }}
            block={block}
            formData={data}
          />
        </SidebarPortal>
      )}
    </>
  );
};

export default Edit;
